<template>
  <v-app>
    <v-img
      style="background-image: linear-gradient(to top left, #646464 0%, #1b1b1b 80%);"
      class="align-center position-absolute"
      height="100%"
    >
      <!-- :src="require('./assets/bg-lucky-min.jpg')" -->
      <!-- <particles-bg
      type="custom"
      :config="config"
      color="black"
      :bg="true"
      style="z-index: 0; background-color: rgb(17, 16, 16)"
    /> -->
      <v-main>
        <router-view />
      </v-main>
    </v-img>
  </v-app>
</template>

<script>
import { ParticlesBg } from "particles-bg-vue";
export default {
  name: "App",
  data() {
    return {
      config: {
        num: [1, 1],
        rps: 0.1,
        radius: [5, 30],
        life: [1.5, 3],
        v: [2, 3],
        tha: [-30, 30],
        alpha: [0.5, 1],
        scale: [0.1, 1],
        position: "all",
        cross: "dead",
        random: 10,
      },
    };
  },
  components: {
    ParticlesBg,
  },
};
</script>

<style>
@import url(./assets/fonts/fontiran.css);

/* *,
body {
  font-family: iranyekan !important;
  letter-spacing: 0 !important;
  font-weight: 200 !important;
} */

* {
  font-family: iranyekan !important;
  letter-spacing: 0 !important;
  font-weight: 800 !important;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #1f1f1f;
  border-radius: 10px;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #fff;
  background-image: linear-gradient(
    90deg,
    rgba(255, 238, 50, 1) 20%,
    rgba(247, 169, 0, 1) 80%
  );
}
</style>
